<template>
     <v-footer
          id="home-footer-simple"
          color="grey darken-4"
          dark
          min-height="72"
     >
          <v-container>
               <v-row no-gutters>
                    <v-col
                         cols="12"
                         lg="8"
                         offset-lg="2"
                         md="10"
                         offset-md="1"
                         sm="12"
                         class="text-md-center"
                    >
                         <div class="d-flex flex-wrap">
                              <template v-for="({ icon, text }, i) in business">
                                   <base-avatar-card
                                        :key="i"
                                        :icon="icon"
                                        :outlined="false"
                                        color="transparent"
                                        horizontal
                                        space="0"
                                   >
                                        <!-- Do not use v-html for user -->
                                        <!-- provided values -->
                                        <div v-html="text" />
                                   </base-avatar-card>
                                   <v-responsive
                                        v-if="i < business.length - 1"
                                        :key="`divider-${i}`"
                                        class="hidden-md-and-down"
                                        max-height="100%"
                                        max-width="100%"
                                   >
                                        <v-divider vertical />
                                   </v-responsive>
                              </template>
                         </div>
                    </v-col>
                    <v-col cols="12" md="12">
                         <p class="pt-3 text-center">
                              Copyright &copy; 2020 Katinks Trinkets
                         </p>
                    </v-col>
               </v-row>
          </v-container>
     </v-footer>
</template>

<script>
export default {
     name: 'HomeFooterSimple',
     data: () => ({
          business: [
               {
                    icon: 'mdi-map-marker-outline',
                    title: 'Address',
                    text: '127 Eastern Avenue #10<br>Gloucester, MA 01930',
               },

               {
                    icon: 'mdi-email',
                    title: 'Email',
                    text:
                         'katina@katinkstrinkets.com<br>sales@katinkstrinkets.com',
               },
          ],
     }),
}
</script>

<style lang="sass">
#home-footer a
  text-decoration: none
</style>
